import React, { useEffect, useMemo, useState } from 'react';
import { TextInput } from '../../../components/textInput/TextInput';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { Grid } from '@mui/material';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { normalizeFilterValue } from '../../../helpers/tools';

const SeleccionarProfesionalContent = ({
    profesionalesPermitidos = [],
    tiposProfesional,
    onRowClick
}) => {
    const [searchValue, setSearchValue] = useState('');
    const [profesionalesFiltered, setProfesionalesFiltered] = useState([]);

    const columns = [
        { field: 'idProfesional', headerName: '#', flex: 1 },
        {
            field: 'idTipoProfesional',
            headerName: '#',
            flex: 1,
            valueGetter: (idTipoProfesional) => (tiposProfesional.find(x => x.id === idTipoProfesional)?.displayName || ''),
        },
        { field: 'nombre', headerName: 'Nombre', flex: 2 },
    ];

    const CONFIGURATED_COLUMNS = useMemo(() => (generateColumnsDefaultConfiguration(columns)), [columns]);

    useEffect(() => {
        setProfesionalesFiltered(profesionalesPermitidos);
    }, [profesionalesPermitidos]);

    useEffect(() => {
        setProfesionalesFiltered(profesionalesPermitidos || []);
    }, [profesionalesPermitidos]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        const filtroBuscar = normalizeFilterValue(value)
        if (!filtroBuscar.length) {
            setProfesionalesFiltered(profesionalesPermitidos);
        } else {
            setProfesionalesFiltered(
                profesionalesPermitidos.filter((prof) =>
                    prof.nombre?.toUpperCase().includes(filtroBuscar) ||
                    prof.idProfesional?.toString().includes(filtroBuscar) ||
                    prof.tipoProfesional?.toUpperCase().includes(filtroBuscar)
                )
            );
        }
    };

    const handleClearSearch = () => {
        setSearchValue('');
        setProfesionalesFiltered(profesionalesPermitidos);
    };

    return (
        <div>
            <p>Haz click sobre un profesional para seleccionarlo.</p>
            <Grid container>
                <Grid sx={{ my: 2.5 }} size={{ xs: 12, md: 4 }}>
                    <TextInput
                        placeholder="Buscar profesional..."
                        value={searchValue}
                        searchIcon
                        onChange={handleSearchChange}
                        onClearButtonClick={handleClearSearch}
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <DataGridGenerico
                        rows={profesionalesFiltered}
                        columns={CONFIGURATED_COLUMNS}
                        toolbar={false}
                        onRowClick={onRowClick}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default SeleccionarProfesionalContent;